import React from 'react';
import { useRouter } from 'next/router';
import Tab from '@mui/material/Tab';
import * as S from './TabContentTemplate.styles';
const getTabPath = (basePath, tabPath) => {
  const concat = basePath + tabPath;
  if (concat.length === 1) return concat;

  // Remove the trailing `/`
  return concat.replace(/\/$/g, '');
};
const TabContentTemplate = ({
  tabs,
  basePath,
  children
}) => {
  const router = useRouter();
  const value = tabs.findIndex(tab => {
    const [currentPath] = router.asPath.split('?');
    return currentPath === getTabPath(basePath, tab.path);
  });
  const handleChange = (_, newValue) => {
    const tab = tabs[newValue];
    router.replace(getTabPath(basePath, tab.path), undefined, {
      shallow: true
    });
    if (!tab) return console.error(`Tab at index ${newValue} not found.`);
    if (tab.effect) {
      tab.effect();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.TabsContainer, null, /*#__PURE__*/React.createElement(S.Tabs, {
    value: value,
    indicatorColor: "secondary",
    textColor: "secondary",
    onChange: handleChange,
    TabIndicatorProps: {
      children: /*#__PURE__*/React.createElement("span", null)
    },
    "aria-label": "Tabs"
  }, tabs.map(tab => {
    const Icon = tab.icon;
    return /*#__PURE__*/React.createElement(Tab, {
      icon: Icon ? /*#__PURE__*/React.createElement(Icon, null) : undefined,
      iconPosition: "start",
      disableFocusRipple: true,
      color: "secondary",
      key: tab.path,
      label: tab.label
    });
  }))), /*#__PURE__*/React.createElement(S.Content, null, children));
};
export default TabContentTemplate;